import dayjs from "dayjs";

const HFormatDate = (
  date: string | undefined | Date,
  variant: "back" | "front" | "form" = "back"
) => {
  if (!date) return "";
  if (variant == "back") {
    return dayjs(date).format("YYYY-MM-DD");
  } else if (variant == "form") {
    return dayjs(date).format("YYYY-MM-DD");
  } else {
    return dayjs(date).format("DD/MM/YYYY hh:mm a");
  }
};

export default HFormatDate;
